import React from 'react';

import classnames from 'classnames';
import ChevronDown from '@andes/icons/ChevronDown20';

import LabelBuilder from '../label-builder';
import { withComponentHandler } from '../../hocs/with-component-handler';
import { CollapsibleCardHeaderPropTypes } from './propTypes';
import { UI_SEARCH_COLLAPSIBLE_CARD_NAMESPACE as namespace } from '../../constants';

/**
 * @typedef {Object} CollapsibleCardHeaderProps
 * @property {string} title - The title text to display in the header
 * @property {boolean} isExpanded - Whether the card is expanded or not
 * @property {Function} onClick - Callback function to handle click events on the header
 */

/**
 * CollapsibleCardHeader component renders the header section of a collapsible card.
 * It includes a title and an expand/collapse icon that rotates based on the expanded state.
 *
 * @param {CollapsibleCardHeaderProps} props - The props for the component
 * @returns {JSX.Element} A button element containing the title and expand/collapse icon
 */
const CollapsibleCardHeader = ({ title, isExpanded, onClick }) => {
  const andesBlueHexCode = '#3483fa';

  return (
    <button className={classnames(`${namespace}__container`)} onClick={onClick} type="button">
      <LabelBuilder tag="h3" class_name={`${namespace}__title`} text={title} styles={{ fontWeight: 'bold' }} />
      <div className={classnames(`${namespace}__icon`, { [`${namespace}__icon--is-expanded`]: isExpanded })}>
        <ChevronDown color={andesBlueHexCode} />
      </div>
    </button>
  );
};

CollapsibleCardHeader.propTypes = {
  ...CollapsibleCardHeaderPropTypes,
};

export default withComponentHandler(CollapsibleCardHeader, { componentName: 'CollapsibleCardHeader' });
